const convertResultsProcessed = sampleCollection => sampleCollection.convertResultsProcessed

export default convertResultsProcessed